module.exports = __webpack_public_path__ + "img/cancel_order.e329dfe3.png";